// services/participantes/motivosService.js
import axios from "axios";

export const getPromotoresByMunicipio = async (municipioId) => {
  try {
    const response = await axios.get("/api/promotores", {
      params: { municipioId }
    });

    return response.data; // 👈 mejor retornar solo la data
  } catch (error) {
    console.error("Error obteniendo promotores:", error);
    throw error;
  }
};
